import { Link } from 'react-router-dom';
import { brandInfo } from '@/mocks/brand';

export default function CommunityHighlight() {
  const { stats, testimonials } = brandInfo;

  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
        <div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            老色哥社区
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mb-8 leading-relaxed">
            汇聚全国超过50万成熟男性用户，分享穿搭心得、交流生活品味。在这里，每一位成熟男士都能找到属于自己的风格和自信。
          </p>

          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-8">
            {stats.map((stat) => (
              <div key={stat.label} className="bg-background-100/70 rounded-lg p-4 text-center">
                <div className="text-xl md:text-2xl font-heading font-bold text-primary-600">{stat.value}</div>
                <div className="text-xs text-foreground-600 mt-1">{stat.label}</div>
              </div>
            ))}
          </div>

          <Link
            to="/about"
            className="inline-flex items-center gap-2 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors duration-200 whitespace-nowrap"
          >
            了解更多关于老色哥 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div>
          <div className="grid grid-cols-1 gap-4">
            {testimonials.slice(0, 3).map((t) => (
              <div key={t.name} className="bg-background-50 rounded-lg border border-background-200/70 p-5">
                <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                  &ldquo;{t.content}&rdquo;
                </p>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                    <img src={t.avatar} alt={t.name} className="w-full h-full object-cover" />
                  </div>
                  <div>
                    <div className="text-sm font-medium text-foreground-900">{t.name}</div>
                    <div className="text-xs text-foreground-500">{t.age} &middot; {t.city}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}